/* eslint-disable */
import type { SVGProps } from 'react';
import { memo } from 'react';

const HH = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1000"
    height="600"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 6"
    {...props}
  >
    <desc>Civil flag of Hesse</desc>
    <rect
      height="3"
      width="10"
      fill="#E10000"
      x="0"
      y="0"
    />
    <rect
      height="3"
      width="10"
      fill="#FFF"
      x="0"
      y="3"
    />
  </svg>
);
export default memo(HH);
